export class forgotPasswordModel{
    email : string;
    byEmail : boolean;
}